// extracted by mini-css-extract-plugin
module.exports = {"LinkedHeading":"LinkedHeading-styles-module--LinkedHeading--2LbtT","anchor":"LinkedHeading-styles-module--anchor--uUPoO","wrapper":"LinkedHeading-styles-module--wrapper--3StVE"};